/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'react-intl';

import config from 'js/app/config';

import { Link, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/xdp';

const styles = {
  footer: css`
    padding: var(--cds-spacing-100) var(--cds-spacing-200);
    color: var(--cds-color-grey-700);
  `,
  privacyLink: css`
    color: inherit !important;
  `,
};

/**
 * Deviates from standard ChatFooter to meet requirements for Two-Panel XDP:
 * - different font with custom color override
 * - custom padding
 * - privacy notice CTA label
 * - does not include the coach persona name
 */
const TwoPanelChatFooter = () => {
  return (
    <Typography2 component="p" variant="bodyTertiary" css={styles.footer}>
      <FormattedMessage
        message={_t(
          `This tool is powered by AI, so check for mistakes and don't share sensitive or personal information. {privacyNotice}.`
        )}
        privacyNotice={
          <Link href={`${config.url.base}about/privacy?trk_ref=coach`} target="_blank" css={styles.privacyLink}>
            {_t(`Learn more`)}
          </Link>
        }
      />
    </Typography2>
  );
};

export default TwoPanelChatFooter;
